// extracted by css-extract-rspack-plugin
export default {"marketRangeText":"market-range-text--l_FnDMcZ0G459Wy0"};